/**
 *
 * @param {*} error
 */
export function error(error) {
  throw new Error(`[Error]: ${error}`);
}
